import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { WorkSubTypePostDataAPI } from '../../../../Redux/SidebarMasterSlice/WorkSubTypeSlice';
import { WorkTypeDDL } from '../../../../Components/CommonDDL/WorkTypeDDL';
import { AstricSign } from '../../../../Helper/AstricSign';
import { ElEWorkTypeDDL } from '../../../../Components/CommonDDL/ElEWorkTypeDDL';
import { Post_M_ELEC_WorkSubType_InsertUpdateAPI } from '../../../../Redux/ElectricalWorkTypeSlice/EleWorkSubTypeSlice';


export default function WorkSubTypePopup(props) {

    const { apiFlag, rowData, open, EditIcon, Flag, handleIsPost, handleOnCloseClick, DashboardName, IsPost } = props


    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()


    const [WorkSubTypeName, setWorkSubTypeName] = useState(Flag === 'Update' ? rowData.workSubTypeName : '')
    const [IsOpen, setIsOpen] = useState(false)
    const [IsLoading, setLoading] = useState(false)

    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WorkTypeID : 0,
        Label: Flag === 'Update' ? rowData.workTypeName : "Select...",
    })

    const [WorkSubTypeField, setWorkSubTypeField] = useState({
        workSubTypeName: Flag === 'Update' ? rowData.workSubTypeName : '',
    })

    const handleWorkSubTypeField = (e) => {
        // console.log(e)
        setWorkSubTypeField({ ...WorkSubTypeField, [e.target.name]: e.target.value })
    }

    const handleClearField = () => {

        if (Flag != 'Update') {
            setWorkSubTypeField('')
        }
    }

    // useEffect(() => {
    //     setWorkSubTypeName(Flag === 'Update' ? rowData.workSubTypeName : '')
    // }, [rowData, IsOpen])

    const handlePost = () => {
        const data = {
            M_WorkSubTypeID: Flag === 'Update' ? rowData.m_WorkSubTypeID : '0',
            M_WorkTypeID: WorkType.ID,
            WorkSubTypeName: WorkSubTypeName,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleClearField: handleClearField,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(WorkSubTypePostDataAPI({ data }))

    }


    const handlePostElE = () => {
        const data = {
            M_ELEC_WorkSubTypeID: Flag === 'Update' ? rowData.m_eleC_WorkSubTypeID : '0',
            M_ELEC_WorkTypeID: WorkType.ID,
            WorkSubTypeName: WorkSubTypeName,
            M_UserID: UserID,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            token: token,
            setLoading: setLoading,
            handleIsPost: handleIsPost,
            handleClearField: handleClearField,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(Post_M_ELEC_WorkSubType_InsertUpdateAPI({ data }))
    }

    return (

        // <Popup
        //     onOpen={() => setIsOpen(!IsOpen)}
        //     contentStyle={{ top: '5%' }}
        //     trigger={
        //         // <i className="fa-solid fa-plus btn btn-secondary mb-2 float-end" style={{ color: "white", marginTop: '-2.5em' }}>
        //         //     <text className="ml-2 poppins">Add</text>
        //         // </i>
        //         Flag === 'Update' ?
        //             <i className="fa-solid fa-pen-to-square" style={{ cursor: "pointer" }} title='Edit'></i>
        //             :
        //             <i className="fa-solid fa-plus btn btn-secondary float-end mb-2" style={{ color: "white", marginTop: '-2.5em' }}>
        //                 <text className="ml-2 poppins">Add</text>
        //             </i>
        //     }
        //     modal>

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Work Sub Type</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                {
                                    DashboardName == "Electrical" ?
                                        <>
                                            <div className="col-12 ">

                                                <ElEWorkTypeDDL
                                                    WorkType={WorkType}
                                                    setWorkType={setWorkType}
                                                    IsPost={IsPost}
                                                    isDisplay={true}
                                                    Flag={Flag}
                                                    ApiFlag="Master"
                                                    rowData={rowData}
                                                />

                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className="col-12 ">
                                                <WorkTypeDDL
                                                    WorkType={WorkType}
                                                    setWorkType={setWorkType}
                                                    rowData={rowData}
                                                    Flag={Flag}
                                                    IsDisabled={true}
                                                />
                                            </div>

                                        </>
                                }

                                <div className="col-12 ">
                                    <label htmlFor="WorkSubType"><b>Work Sub Type <AstricSign /> </b></label>
                                    <input type="text" className="form-control" id="exampleInputEmail1"
                                        aria-describedby="emailHelp"
                                        value={WorkSubTypeName}
                                        onChange={(e) => setWorkSubTypeName(e.target.value)}
                                    />
                                </div>
                            </div>

                            {/* <div className="mb-4 pt-4">
                                        <div className="float-end">
                                            <span className="submit_btn"
                                             disabled={
                                                WorkType.ID === 0 && WorkSubTypeName === ''
                                            }
                                                onClick={() => (handlePost())}
                                            >{Flag === 'Update' ? 'Update' : 'Save'}</span>
                                            <span className=" cancel_btn ms-2" onClick={handleOnCloseClick} >Cancel</span>
                                        </div>
                                    </div> */}

                            <div className="col-12 col-lg-12 pt-lg-5">
                                <div className="btn-action d-flex justify-content-end">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => { DashboardName =="Electrical" ? handlePostElE() : handlePost()}}
                                        disabled={
                                            WorkType.ID == 0 || WorkSubTypeName == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}